import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { Machine } from '../../core/models';

@Component({
  selector: 'app-machines',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './machines.component.html',
  styleUrl: './machines.component.scss',
})
export class MachinesComponent implements OnInit {
  private api = inject(ApiService);
  machines = signal<Machine[]>([]);
  showForm = signal(false);
  form = {
    name: '',
    manufacturer: '',
    model: '',
    serial_number: '',
    location: '',
    notes: '',
  };

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.api.get<Machine[]>('/api/machines').subscribe((m) => this.machines.set(m));
  }

  create(): void {
    this.api.post<Machine>('/api/machines', this.form).subscribe(() => {
      this.showForm.set(false);
      this.form = { name: '', manufacturer: '', model: '', serial_number: '', location: '', notes: '' };
      this.reload();
    });
  }
}
